// extracted by mini-css-extract-plugin
export default {"list":"ie9tm","list-item":"Hk7mj","back-link":"sArgL"};